import { render, staticRenderFns } from "./purposeText.vue?vue&type=template&id=30c2f0da&scoped=true"
import script from "./purposeText.vue?vue&type=script&lang=js"
export * from "./purposeText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c2f0da",
  null
  
)

export default component.exports